import { useT } from "../lang/LangContext";

export function SchoolNow() {
  const t = useT();

  return (
    <section
      style={{ maxWidth: 1180, margin: "0 auto", padding: "36px 20px 64px" }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
          gap: 22,
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: 14,
              marginBottom: 20,
            }}
          >
            <span
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 14,
                color: "var(--accent)",
              }}
            >
              05
            </span>
            <h2
              style={{
                margin: 0,
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: "clamp(26px,4vw,40px)",
                letterSpacing: "-0.03em",
                textTransform: "uppercase",
              }}
            >
              {t("School", "Formação")}
            </h2>
          </div>
          <div
            style={{
              border: "3px solid var(--fg)",
              padding: 22,
              background: "var(--card)",
            }}
          >
            <div
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 19,
                lineHeight: 1.2,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              {t(
                "B.S. Computer Engineering",
                "Bacharelado em Engenharia de Computação"
              )}
            </div>
            <div style={{ fontSize: 14, lineHeight: 1.6 }}>
              Universidade Federal de Uberlândia
            </div>
            <div
              style={{
                fontSize: 12,
                letterSpacing: "0.14em",
                marginTop: 10,
                color: "var(--accent)",
              }}
            >
              2018 → 2024
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: 14,
              marginBottom: 20,
            }}
          >
            <span
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 14,
                color: "var(--accent)",
              }}
            >
              06
            </span>
            <h2
              style={{
                margin: 0,
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: "clamp(26px,4vw,40px)",
                letterSpacing: "-0.03em",
                textTransform: "uppercase",
              }}
            >
              Now
            </h2>
          </div>
          <div
            style={{
              border: "3px solid var(--bg)",
              background: "var(--accent)",
              color: "var(--bg)",
              padding: 22,
              boxShadow: "8px 8px 0 var(--fg)",
            }}
          >
            <div
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: "clamp(28px,5vw,46px)",
                lineHeight: 0.95,
                letterSpacing: "-0.03em",
                textTransform: "uppercase",
              }}
            >
              {t("Grinding 24/7", "Na correria 24/7")}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
